<template>
  <b-container fluid>
    <b-card>
      <b-form-file
        v-model="file"
        accept=".xlsx"
        @input="handleFileUpload"
      ></b-form-file>
      <b-button @click="uploadFile">Upload</b-button>
    </b-card>
    <b-table
      responsive
      striped
      hover
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :items="results"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      @filtered="onFiltered"
      class="table-romeflex"
    >
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="results.length"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </b-container>
</template>

<script>
import * as XLSX from 'xlsx'
import MeritOrderProductsService from '@/services/MeritOrderProductsService'

export default {
  components: {
  },
  mounted () {
    this.getMeritOrderProducts()
  },
  data () {
    return {
      file: null,
      filter: null,
      sortBy: 'productCode',
      sortDesc: true,
      results: [],
      fields: [
        { key: 'productCode', label: 'productCode', sortable: true },
        { key: 'bspCode', label: 'bspCode', sortable: true },
        { key: 'idBlock', label: 'idBlock', sortable: true },
        { key: 'acceptedPrice', label: 'acceptedPrice', sortable: true },
        { key: 'acceptedPriceAvailability', label: 'acceptedPriceAvailability', sortable: true },
        { key: 'acceptedQty', label: 'acceptedQty' },
        { key: 'gmeReferenceNumber', label: 'gmeReferenceNumber' },
        { key: 'meritOrder', label: 'meritOrder' },
        { key: 'qty', label: 'qty' }
      ],
      form: {},
      currentPage: 1,
      perPage: 10
    }
  },
  methods: {
    async getMeritOrderProducts () {
      const response = await MeritOrderProductsService.getMeritOrderProducts()
      this.results = response.data
    },
    handleFileUpload (file) {
      this.file = file
    },
    async uploadFile () {
      if (!this.file) {
        this.$bvToast.toast('Seleziona un file prima di eseguire l\'upload.', {
          title: 'Attenzione',
          variant: 'warning'
        })
        return
      }

      try {
        const workbook = await this.readFile()
        const sheet = workbook.Sheets[workbook.SheetNames[0]]
        const data = XLSX.utils.sheet_to_json(sheet, { header: 1 })

        const fileName = this.file.name

        for (let i = 1; i < data.length; i++) {
          const row = data[i]
          const [
            productCode,
            bspCode,
            gmeReferenceNumber,
            qty,
            acceptedQty,
            meritOrder,
            acceptedPrice,
            acceptedPriceAvailability
          ] = row

          await MeritOrderProductsService.save({
            idBlock: fileName,
            productCode,
            bspCode,
            gmeReferenceNumber,
            qty,
            acceptedQty,
            meritOrder,
            acceptedPrice,
            acceptedPriceAvailability
          })
        }
        this.getMeritOrderProducts()

        this.$bvToast.toast('File uploaded successfully!', {
          title: 'Success',
          variant: 'success'
        })
      } catch (error) {
        console.error('Error uploading file:', error)
        this.$bvToast.toast('An error occurred while uploading the file.', {
          title: 'Error',
          variant: 'danger'
        })
      }
    },
    readFile () {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result)
          const workbook = XLSX.read(data, { type: 'array' })
          resolve(workbook)
        }
        reader.onerror = (error) => reject(error)
        reader.readAsArrayBuffer(this.file)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MeritOrderProducts.vue